import { __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { px2rem } from '../../helpers/rem.mjs';
import LoadingIcon from './icon/index.mjs';

var DefaultLoaderWrapper = styled.div.withConfig({
  displayName: "DefaultLoaderWrapper",
  componentId: "sc-1e3s9m4-0"
})(["margin:", " 0;"], px2rem(20));
function DefaultLoader(_a) {
  var rest = __rest(_a, []);
  return jsx(DefaultLoaderWrapper, {
    children: jsx(LoadingIcon, Object.assign({}, rest))
  });
}

export { DefaultLoader, DefaultLoaderWrapper, LoadingIcon };
